export const ufs = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export const ProjectTypes = {
  SOLAR_ENERGY: 'SOLARY_ENERGY',
  PMUC: 'PMUC',
  AIR_SUBSTATION: 'AIR_SUBSTATION',
  VEHICLE_CHARGERS: 'VEHICLE_CHARGERS',
  SPDA: 'SPDA',
  FIRE_FIGHTING: 'FIRE_FIGHTING_PROJECT',
  PROTECTION_COORDINATION_SELECTIVITY: 'PROTECTION_COORDINATION_SELECTIVITY',
  ELETRIFICATION_OF_SUBDIVISION: 'ELETRIFICATION_OF_SUBDIVISION',
  INDUSTRIAL_ELECTRICAL_INSTALLATIONS: 'INDUSTRIAL_ELECTRICAL_INSTALLATIONS',
  RESIDENTIAL_COMMERCIAL_ELECTRICAL_INSTALLATIONS:
    'RESIDENTIAL_COMMERCIAL_ELECTRICAL_INSTALLATIONS',
  SPDA_REPORT: 'SPDA_REPORT',
  ADEQUACY_ELECTRICAL_INSTALLATIONS_REPORT:
    'ADEQUACY_ELECTRICAL_INSTALLATIONS_REPORT',
  GROUNDING_REPORT: 'GROUNDING_REPORT',
  PUBLIC_LIGHTING: 'PUBLIC_LIGHTING',
  ICMS_REPORT: 'ICMS_REPORT',
};

export const projects = {
  [ProjectTypes.SOLAR_ENERGY]: 'Energia Solar',
  [ProjectTypes.PMUC]: 'Medição Agrupada (PMUC)',
  [ProjectTypes.AIR_SUBSTATION]: 'Subestação Aérea/Abrigada',
  // [ProjectTypes.VEHICLE_CHARGERS]: "Carregadores Veiculares",
  // [ProjectTypes.SPDA]: "SPDA",
  // [ProjectTypes.FIRE_FIGHTING]: "Combate a Incêndio",
  // [ProjectTypes.PROTECTION_COORDINATION_SELECTIVITY]:
  //   "Estudo de Proteção, Coordenação e Seletividade",
  // [ProjectTypes.ELETRIFICATION_OF_SUBDIVISION]: "Eletrificação de Loteamento",
  // [ProjectTypes.INDUSTRIAL_ELECTRICAL_INSTALLATIONS]: "Instalações Elétricas Industriais",
  // [ProjectTypes.RESIDENTIAL_COMMERCIAL_ELECTRICAL_INSTALLATIONS]:
  //   "Instalações Elétricas Residenciais/Comerciais",
  // [ProjectTypes.SPDA_REPORT]: "Laudo de SPDA",
  // [ProjectTypes.ADEQUACY_ELECTRICAL_INSTALLATIONS_REPORT]:
  //   "Laudo de Adequação de Instalações Elétricas",
  // [ProjectTypes.GROUNDING_REPORT]: "Laudo de Aterramento",
  // [ProjectTypes.PUBLIC_LIGHTING]: "Iluminação Pública",
  // [ProjectTypes.ICMS_REPORT]: "Laudo de ICMS",
};

export const listDisjuntores = [
  '2 A',
  '4 A',
  '6 A',
  '10 A',
  '16 A',
  '20 A',
  '25 A',
  '32 A',
  '40 A',
  '50 A',
  '63 A',
  '70 A',
  '80 A',
  '100 A',
  '125 A',
  'Outro',
];

export const inputMaskMapper = {
  cpf: '999.999.999-99',
  client_cpf: '999.999.999-99',
  cnpj: '99.999.999/9999-99',
  client_cnpj: '99.999.999/9999-99',
  phone: '(99) 99999-9999',
};
